const buttonsStars = document.querySelectorAll(".button--star");

buttonsStars.forEach((button) => {
  const stars = button.querySelectorAll(".star");
  let animationInterval;

  function randomTransform() {
    stars.forEach((star) => {
      const x = Math.random() * 40 - 20;
      const y = Math.random() * 40 - 20;
      star.style.transform = `translate(${x}px, ${y}px)`;
    });
  }

  button.addEventListener("mouseenter", () => {
    randomTransform();
    animationInterval = setInterval(randomTransform, 3000);
  });

  button.addEventListener("mouseleave", () => {
    clearInterval(animationInterval);
    stars.forEach((star) => {
      star.style.transform = "translate(0, 0)";
    });
  });
});
